import React from 'react';
import { useTranslation } from 'react-i18next';
import { dateFromLocalKey } from './dateUtils';
import { useTimelineView } from './TimelineViewContext';

export const TimelineFloatingAdd = () => {
    const { t } = useTranslation();
    const {
        creationMenuKey, creationMenuRef, draftSelection, onCreateFlexibleTask, onCreateTimedTask,
        activeTimelineDateKey, onGoToNow, onPickExistingTask, selectedDate, setCreationMenuKey,
        timelineScale, timelineZoomAnchorDate,
    } = useTimelineView();
    if (draftSelection) return null;
    const isOpen = creationMenuKey === 'timeline-floating';
    const headerDate = timelineZoomAnchorDate || (activeTimelineDateKey
        ? dateFromLocalKey(activeTimelineDateKey) : selectedDate);
    const createTask = () => {
        const precisionByScale = { month: 'day', year: 'month', years: 'year' } as const;
        const precision = precisionByScale[timelineScale as keyof typeof precisionByScale];
        if (precision) onCreateFlexibleTask(headerDate, precision);
        else onCreateTimedTask(headerDate);
        setCreationMenuKey(null);
    };
    return <>
        <button type="button" className="timeline-floating-today" onClick={onGoToNow}>
            {t('dailyPlanner.today')}
        </button>
        <div ref={isOpen ? creationMenuRef : undefined} className="timeline-floating-add">
            <button type="button" className="schedule-add-task-button"
                onClick={() => setCreationMenuKey(isOpen ? null : 'timeline-floating')}
                aria-label={t('dailyPlanner.addTask')} title={t('dailyPlanner.addTask')}>+</button>
            {isOpen && (
                <div className="timeline-create-choice-menu timeline-floating-choice-menu" role="menu">
                    <button type="button" role="menuitem"
                        onClick={createTask}>
                        {t('dailyPlanner.newTask')}
                    </button>
                    <button type="button" role="menuitem"
                        onClick={() => { onPickExistingTask(headerDate); setCreationMenuKey(null); }}>
                        {t('dailyPlanner.existingTask')}
                    </button>
                </div>
            )}
        </div>
    </>;
};
